import {CSSObject} from '@chakra-ui/react';

import {dataGridGlobalTheme} from '../../../styles/DataGrid/Global.theme';

export const globalOverrides: CSSObject = {
  ...dataGridGlobalTheme,
};
